import MagicWandIcon from '@atlaskit/icon/core/magic-wand';
import * as React from 'react';

export function SvgQuickEdit() {
  return <MagicWandIcon label="" testId="ads-refreshed-icon" />;
}
